/** iframe HTML for embedding a public org widget (`?embed=1` URLs). */
export function buildOrgEmbedIframeSnippet(
  url: string,
  title: string,
  options?: { allowPayment?: boolean }
): string {
  const allowPayment = options?.allowPayment ? ' allow="payment *"' : '';
  return `<iframe src="${url}" title="${title}" style="width:100%;min-height:720px;border:0;" loading="lazy"${allowPayment}></iframe>`;
}
